module.exports = __webpack_public_path__ + "static/img/sub-page01@t.9324a01.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/discover/sub-page01@t.jpg
// module id = euw1
// module chunks = 0